import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const SiteContentContext = createContext(null);

const FALLBACK = {
  hero_eyebrow: { fi: "Käsintehtyjä pikkuruisuuksia", en: "Handmade little treasures", sv: "Handgjorda små skatter" },
  hero_title: { fi: "Pieniä\naarteita\nkäsin tehden.", en: "Tiny\ntreasures,\nhand-made.", sv: "Små\nskatter,\nhandgjorda." },
  hero_lede: { fi: "", en: "", sv: "" },
  story_title: { fi: "Käsi, savi, tuli.", en: "Hand, clay, fire.", sv: "Hand, lera, eld." },
  story_body: { fi: "", en: "", sv: "" },
  showcase_title: { fi: "", en: "", sv: "" },
  showcase_body: { fi: "", en: "", sv: "" },
  footer_address: { fi: "", en: "", sv: "" },
  footer_email: { fi: "", en: "", sv: "" },
  footer_phone: { fi: "", en: "", sv: "" },
};

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(FALLBACK);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/site-content");
      setContent({ ...FALLBACK, ...r.data });
    } catch {}
    setLoaded(true);
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SiteContentContext.Provider value={{ content, loaded, refresh }}>
      {children}
    </SiteContentContext.Provider>
  );
}

export const useSiteContent = () => useContext(SiteContentContext);
